
import stock from '@/pages/stock/stock'
import stockRecord from '@/pages/stock/stock-record'
import layout from '@/components/layout/layout'
const stockRouter =
{
  path: '/stock',
  component: layout,
  meta: {roles: ['shop', 'r4gys'], title: '库存管理', icon: 'icon-kucunguanli'},
  children: [
    {
      path: '/stock/manage',
      component: stock,
      name: 'stock',
      meta: {roles: ['shop', 'r4gys'], title: '库存管理'}
    },
    {
      path: '/stock/stockRecord',
      component: stockRecord,
      hidden: true,
      name: 'stockRecord',
      meta: {roles: ['shop', 'r4gys']}
    }
  ]
}
export default stockRouter



// WEBPACK FOOTER //
// ./src/router/modules/stockRouter.js